import Arquivo from "model/arquivo/Arquivo";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaPrevista from "model/viagem/ViagemDespesaPrevista";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import ModalVerPdf from "../ModalVerPdf";


type Props = {
    visible: boolean;
    onHide: () => void;
    arquivos: Arquivo[];
}

export default function ModalDespesaVerArquivos(props: Props) {

    const [photoOpen, setPhotoOpen] = useState(false);
    const [urlOpened, setUrlOpened] = useState('');
    const [modalVerPdf, setModalVerPdf] = useState<{ visible: boolean, url: string }>({ visible: false, url: '' });

    return (
        <Dialog header="Imagens" visible={props.visible} baseZIndex={10} style={{ width: '50vw' }} onHide={() => { props.onHide() }}>
            {photoOpen && <Lightbox
                mainSrc={urlOpened}
                onCloseRequest={() => setPhotoOpen(false)}
                reactModalStyle={{ overlay: { zIndex: 99999 } }}
            />}

            {modalVerPdf.visible && <ModalVerPdf
                visible={modalVerPdf.visible}
                onHide={() => setModalVerPdf({ visible: false, url: '' })}
                url={modalVerPdf.url}
            />}

            <div style={{ display: "flex" }}>

                {props.arquivos.map((imagem, index) => {
                    if (imagem.imagem) {
                        return (
                            <div key={index} style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                                <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                    <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => {
                                        setTimeout(() => {
                                            setPhotoOpen(true)
                                            setUrlOpened(imagem.url)

                                        }, 100)
                                    }}>
                                        <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                    </a>
                                </div>
                            </div>
                        )
                    }
                    return (
                        <div key={index} style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                            <div key={`pdf${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                <a
                                    className='p-lightbox-image-target'
                                    style={{ cursor: 'pointer', height: 128, width: 128, display: "flex", alignItems: "center", justifyContent: "center" }}
                                    onClick={() => {
                                        setModalVerPdf({ visible: true, url: imagem.url })
                                    }}>
                                    <i style={{ fontSize: 64, color: "#FF5555" }} className="pi pi-file-pdf" />
                                </a>
                            </div>
                        </div>
                    )
                })}
            </div>
        </Dialog>
    )
}